import { useState } from 'react';
import { App, Modal } from 'antd';
import type { Folder } from '@core/entities/Folder';
import { MarkdownEditor } from '@presentation/components/workbench/MarkdownEditor';
import { useUpdateFolder } from '@presentation/hooks/useFolders';

interface FolderDocsModalProps {
  folder: Folder;
  open: boolean;
  onClose: () => void;
}

export const FolderDocsModal = ({ folder, open, onClose }: FolderDocsModalProps) => {
  const { message } = App.useApp();
  const updateFolder = useUpdateFolder(folder.id);
  const [description, setDescription] = useState(folder.description ?? '');

  const [wasOpen, setWasOpen] = useState(open);
  if (open !== wasOpen) {
    setWasOpen(open);
    if (open) {
      setDescription(folder.description ?? '');
    }
  }

  const handleSave = () => {
    updateFolder.mutate(
      { description },
      {
        onSuccess: () => {
          void message.success('Documentation saved');
          onClose();
        },
      },
    );
  };

  return (
    <Modal
      open={open}
      title={`Documentation — ${folder.name}`}
      onCancel={onClose}
      onOk={handleSave}
      confirmLoading={updateFolder.isPending}
      width={720}
      destroyOnHidden
    >
      <MarkdownEditor
        value={description}
        onChange={setDescription}
        placeholder="Document what this folder contains and how its requests are organized…"
        minHeight={320}
      />
    </Modal>
  );
};
